import Application from './core'

/**
 * Bootstrap application
 *
 * Load and setup thrid party dependencies.
 */
require('./bootstrap');

/**
 * Boot application
 */
window.App = new Application()



// WEBPACK FOOTER //
// ./resources/js/app.js